import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { JardinModel } from 'src/app/model/Jardin.model';
import { CentroSaludCercano, CentroSaludParbulos, ReglamentoInternoModel, ResponseReglamentoInterno } from 'src/app/model/ReglamentoInterno.model';
import { apiService } from 'src/app/service/api.service';
import { ReglamentoInternoService } from 'src/app/service/reglamentoInterno.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { PreviewComponent } from 'src/app/components/preview/preview.component';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';

@Component({
  selector: 'app-reglamento-interno',
  templateUrl: './reglamento-interno.component.html',
  styleUrls: ['./reglamento-interno.component.css']
})
export class ReglamentoInternoComponent implements OnInit {

  @Input() simulacion: boolean;
  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;
  dataJardin = new JardinModel();
  reglamentoInternoModel = new ReglamentoInternoModel();
  public isCollapsed1 = true;
  public isCollapsed2 = true;
  public isCollapsed3 = true;
  public isCollapsed4 = true;
  public isCollapsed5 = true;
  public isCollapsed6 = true;
  public isCollapsed7 = true;

  url: string;
  urlSafe: SafeResourceUrl;
  apiEndpoint = environment.apiEndpoint;
  dataArchivo = new FormData();
  archivoCargado = false;
  parametroSubida:number =0;
  parametroMonstrarSubida:number =0;
  spinnerRef:any;

  
  constructor(
     public dialog: MatDialog,
    private api: apiService,
    private spinner: NgxSpinnerService,
    private modal: NgbModal,
    private reglamentoInternoService: ReglamentoInternoService,
    public sanitizer: DomSanitizer,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.dataJardin = this.api.dataJardin;
    this.getReglamentoInterno();
    this.obtenerParametroRI();
  }

  getReglamentoInterno(){
    this.reglamentoInternoService.API_GET_getReglamentoInterno(this.dataJardin.idJardinPeriodo).subscribe((response: ResponseReglamentoInterno) => {
      this.reglamentoInternoModel = response.payload;  
      this.spinner.hide();
    },
    (err) => {
      this.spinner.hide();
      console.log(err);
    });      
  }



  agregarcentroParbulo(){
    this.reglamentoInternoModel.centroSaludParbulos.push(new CentroSaludParbulos);
  }

  agregarcentroCercano(){
    this.reglamentoInternoModel.centroSaludCercano.push(new CentroSaludCercano);
  }

  guardar(){
    console.log(this.reglamentoInternoModel);
    this.spinner.show();
    this.reglamentoInternoService.API_POST_saveReglamentoInterno(this.dataJardin.idJardinPeriodo, this.reglamentoInternoModel).subscribe((response: ResponseReglamentoInterno) => {
      this.reglamentoInternoModel = response.payload;  
      this.spinner.hide();
    },
    (err) => {
      this.spinner.hide();
      console.log(err)
    });     
  }

  imprimir(){
    this.url = this.apiEndpoint + 'reglamentoInterno/imprimir/' + this.dataJardin.idJardinPeriodo;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInforme, { size: 'xl' });
  }

  close(){
    this.modal.dismissAll();
  }
  
  enviar(){
    if(this.reglamentoCompleto()){
      Swal.fire({
        title: '¿desea enviar?',
        text: 'Se realizará el envío del Reglamento Interno dejando esta como fecha de Elaboración. ',
        icon: 'question',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinner.show();
          this.reglamentoInternoService.API_PUT_enviarReglamentoInterno(this.dataJardin.idJardinPeriodo, this.reglamentoInternoModel).subscribe((response: ResponseReglamentoInterno) => {
            this.reglamentoInternoModel = response.payload;  
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            console.log(err)
          });      
        }
      })
    }
  }

  reglamentoCompleto(): boolean{
    var reglamentoCompleto = true;

    /*if (this.reglamentoInternoModel.jardinExtraData.representanteLegal != "" && this.reglamentoInternoModel.jardinExtraData.telefonoFijo != "" && this.reglamentoInternoModel.jardinExtraData.movilInstitucional != "" &&
        this.reglamentoInternoModel.jardinExtraData.directoraSubrogante != "" && this.reglamentoInternoModel.jardinExtraData.correoDirectoraSubrogante != "" && this.reglamentoInternoModel.jardinExtraData.telefonoFijoDirectoraSubrogante != "" &&
        this.reglamentoInternoModel.jardinExtraData.movilInstitucionalDirectoraSubrogante != "" && this.reglamentoInternoModel.jardinExtraData.correoEstablecimientoDirectoraSubrogante != "" && this.reglamentoInternoModel.jardinExtraData.rroNumero != null &&
        this.reglamentoInternoModel.jardinExtraData.rroFecha != null && this.reglamentoInternoModel.jardinExtraData.rroRbd != null){
      reglamentoCompleto = true;
    }else {
      Swal.fire({
        title: 'Faltan Datos',
        text: 'Para envíar debe rellenar los datos faltantes en Identificación y Antecedentes del Jardín Infantil',
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return false;
    }

    if (this.reglamentoInternoModel.estructuraNiveles.numSalasSCMenor != null && this.reglamentoInternoModel.estructuraNiveles.edadSCMenor != null && this.reglamentoInternoModel.estructuraNiveles.numSalasSCMayor != null && this.reglamentoInternoModel.estructuraNiveles.edadSCMayor != null &&
        this.reglamentoInternoModel.estructuraNiveles.numSalasSCHG != null && this.reglamentoInternoModel.estructuraNiveles.edadSCHG != null && this.reglamentoInternoModel.estructuraNiveles.numSalasMMenor != null && this.reglamentoInternoModel.estructuraNiveles.edadMMenor != null &&
        this.reglamentoInternoModel.estructuraNiveles.numSalasMMayor != null && this.reglamentoInternoModel.estructuraNiveles.edadMMayor != null && this.reglamentoInternoModel.estructuraNiveles.numSalasMHG != null && this.reglamentoInternoModel.estructuraNiveles.edadMHG != null &&
        this.reglamentoInternoModel.estructuraNiveles.numSalasPNT != null && this.reglamentoInternoModel.estructuraNiveles.edadPNT != null && this.reglamentoInternoModel.estructuraNiveles.numSalasSNT != null && this.reglamentoInternoModel.estructuraNiveles.edadSNT != null &&
        this.reglamentoInternoModel.estructuraNiveles.numSalasTHG != null && this.reglamentoInternoModel.estructuraNiveles.edadTHG != null && this.reglamentoInternoModel.estructuraNiveles.numSalasMTHG != null && this.reglamentoInternoModel.estructuraNiveles.edadMTHG != null){
      reglamentoCompleto = true;
    }else {
      Swal.fire({
        title: 'Faltan Datos',
        text: 'Para envíar debe rellenar los datos faltantes en Regulación sobre estructuras en niveles educativos y la trayectoria de los párvulos',
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return false;
    }

    if (this.reglamentoInternoModel.mediosComunicacion != ""){
      reglamentoCompleto = true;
    }else {
      Swal.fire({
        title: 'Faltan Datos',
        text: 'Para envíar debe rellenar los datos faltantes en Medios de comunicación correspondiente a la Unidad Educativa',
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return false;
    }*/

    if (this.reglamentoInternoModel.centroSaludParbulos.length >= 1 && this.reglamentoInternoModel.centroSaludParbulos.length <= 3){
      reglamentoCompleto = true;

      const centroSaludParvulos = this.reglamentoInternoModel.centroSaludParbulos;

      for (let i = 0; i < centroSaludParvulos.length; i++){
        if (centroSaludParvulos[i].centroSalud != "" && centroSaludParvulos[i].direccion != "" && centroSaludParvulos[i].comunaLocalidad != ""){
          reglamentoCompleto = true;
        }else{
          Swal.fire({
            title: 'Faltan Datos',
            text: 'Para envíar debe rellenar los datos faltantes en Centros de salud para atención de Párvulos',
            icon: 'info',
            confirmButtonText: 'OK'
          });

          return false;
        }
      }
    }else {
      Swal.fire({
        title: 'Faltan Datos',
        text: 'Para envíar debe ingresar al menos uno y hasta tres Centros de Salud en Centros de salud para atención de Párvulos',
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return false;
    }

    /*if (this.reglamentoInternoModel.institucionDenuncia.direccionMP != "" && this.reglamentoInternoModel.institucionDenuncia.comunaLocalidadMP != "" &&
        this.reglamentoInternoModel.institucionDenuncia.direccionCarab != "" && this.reglamentoInternoModel.institucionDenuncia.comunaLocalidadCarab != "" &&
        this.reglamentoInternoModel.institucionDenuncia.direccionPDI != "" && this.reglamentoInternoModel.institucionDenuncia.comunaLocalidadPDI != "" &&
        this.reglamentoInternoModel.institucionDenuncia.direccionTCP != "" && this.reglamentoInternoModel.institucionDenuncia.comunaLocalidadTCP != ""){
      reglamentoCompleto = true;
    }else {
      Swal.fire({
        title: 'Faltan Datos',
        text: 'Para envíar debe rellenar los datos faltantes en Institución Denuncia',
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return false;
    }*/

    if (this.reglamentoInternoModel.centroSaludCercano.length >= 1){
      reglamentoCompleto = true;

      const centroSaludCercano = this.reglamentoInternoModel.centroSaludCercano;

      for (let i = 0; i < centroSaludCercano.length; i++){
        if (centroSaludCercano[i].nombre != "" && centroSaludCercano[i].direccion != "" && centroSaludCercano[i].telefono != ""){
          reglamentoCompleto = true;
        }else{
          Swal.fire({
            title: 'Faltan Datos',
            text: 'Para envíar debe rellenar los datos faltantes en Centros de Salud Cercano al Establecimiento',
            icon: 'info',
            confirmButtonText: 'OK'
          });

          return false;
        }
      }
    }else {
      Swal.fire({
        title: 'Faltan Datos',
        text: 'Para envíar debe ingresar al menos un Centro de Salud Cercano al Establecimiento',
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return false;
    }

    return reglamentoCompleto;
  }

  cambioArchivo(event){
    this.dataArchivo = new FormData();
    const extension = event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf(".") + 1, event.target.files[0].name.length)
    const extensionesValidas = ["pdf"];
    const existeExtension = extensionesValidas.map(x=> x).indexOf(extension.toLowerCase());
    this.archivoCargado = false;
    if(existeExtension == -1){
      Swal.fire({
        title: 'Error!',
        text: 'Ingrese un archivo valido',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }else{
      this.dataArchivo.append('file', event.target.files[0]);
      this.archivoCargado = true;
    }
  }

  descargar(){
    this.url = this.apiEndpoint + 'reglamentoInterno/imprimir/' + this.dataJardin.idJardinPeriodo;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInforme, { size: 'xl' });
  }

  public verArchivo(): void {

    let path = this.apiEndpoint + "reglamentoInterno/imprimir/"+this.dataJardin.idJardinPeriodo;
    let realName = "reglamentointerno.pdf";
      const dialogRef = this.dialog.open(PreviewComponent, {
      disableClose: true,
          data: {file: path, name: realName }
      });
  }

  subirArchivo(event){
    if(this.archivoCargado){
      this.spinnerRef = this.spinnerService.start();
      this.reglamentoInternoService.API_POST_guardarArchivoReglamento(this.dataJardin.idJardinPeriodo, this.dataArchivo).subscribe((response: ResponseReglamentoInterno) => {
        this.reglamentoInternoModel = response.payload;
        this.parametroMonstrarSubida = 0;
        this.spinnerService.stop(this.spinnerRef);
        Swal.fire({
          title: 'OK',
          text: 'Subido correctamente',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      },
      (err) => {
        this.spinnerService.stop(this.spinnerRef);
        Swal.fire({
          title: 'UPS!',
          text: 'El archivo supera el peso máximo (3 mb)',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        console.log(err);
      });
    } else {
      this.spinnerService.stop(this.spinnerRef);
      Swal.fire({
        title: 'Error!',
        text: 'Ingrese un archivo valido',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  }

    obtenerParametroRI(){
 
      this.api.API_GET_OtenerParametroRI().subscribe((response:any) => {
        this.parametroSubida = response.payload;

      },
      (err) => { 
        console.log(err)
   
        Swal.fire({
          title: 'Error al Cargar Jardín',
          text: 'Validar que el Código del jardín sea correcto.',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      });
  }
}
